import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHome24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconHome24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m12 2.373.507.464 9.476 8.686a.75.75 0 0 1-1.014 1.106L20 11.74V18a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-6.259l-.968.888a.75.75 0 1 1-1.014-1.106l9.476-8.686zm0 2.034 6.5 5.959V18a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 18v-7.634zm-2.808 8.545c-.08-.351-.047-.664.339-1.059.292-.299.49-.365.576-.383a.54.54 0 0 1 .306.032 1.35 1.35 0 0 1 .466.3l.01.012.003.002a1.5 1.5 0 0 0 2.217 0l.001-.002.011-.011a1 1 0 0 1 .104-.09c.104-.084.232-.164.362-.211a.54.54 0 0 1 .306-.032c.085.018.284.084.577.383.385.395.419.708.338 1.059-.107.466-.453 1.048-1.02 1.686-.546.615-1.193 1.165-1.72 1.57l-.068.051-.067-.051c-.528-.405-1.175-.955-1.721-1.57-.567-.638-.913-1.22-1.02-1.686M12 10.845s.133-.15.364-.323c.594-.444 1.841-1.045 3.178.323C18.58 13.95 12 18.093 12 18.093s-6.578-4.142-3.542-7.248c1.337-1.368 2.584-.767 3.178-.323.232.173.364.323.364.323"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHome24);
